export const options = [
  { label: 'Jobs', value: 'Jobs' },
  { label: '1st technical interview', value: '1st technical interview' },
  { label: '2nd technical interview', value: '2nd technical interview' },
  { label: 'Test dome', value: 'Test dome' },
  { label: 'Client interview', value: 'Client interview' },
  { label: 'Make an offer', value: 'Make an offer' },
];
